/**
 * Clean error message by removing the [ERROR_TYPE] Code: XXX, Message: prefix
 * @param message - The raw error message
 * @returns The cleaned error message
 */
export const cleanErrorMessage = (message?: string): string => {
    if (!message) return ''
    return message.replace(/^\[.*?\]\s*Code:\s*\d+,\s*Message:\s*/i, '') || message
}